export default __webpack_public_path__ + "static/media/email_logo.b07f1463.svg";